export const FETCH_ADVISER_DATA_SUCCESS = 'FETCH_ADVISER_DATA_SUCCESS';

export const FETCH_ADVISER_DATA_FAILURE = 'FETCH_ADVISER_DATA_FAILURE';